/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

import { withNoTranslate } from "./noTranslate";

export const getUserTimezoneAbbreviation = (): string => {
  try {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timeZoneName: "short",
    });

    const parts = formatter.formatToParts(date);
    const timeZonePart = parts.find((part) => part.type === "timeZoneName");
    const timezone = timeZonePart ? timeZonePart.value : "";

    // 日本時間（JST/GMT+9）の場合は空文字を返す
    if (timezone === "GMT+9" || timezone === "JST") {
      return "";
    }

    return timezone;
  } catch {
    return "";
  }
};

/**
 * ユーザーのタイムゾーンを表示するコンポーネント
 * 使用例: <TimezoneDisplay />
 * 使用例(スタイル上書き): <TimezoneDisplay customStyle={css`font-size: 1em;`} />
 */
export const TimezoneDisplay: React.FC<{
  customStyle?: ReturnType<typeof css>;
}> = ({ customStyle }) => {
  const timezone = React.useMemo(() => {
    return getUserTimezoneAbbreviation();
  }, []);

  if (!timezone) {
    return null;
  }

  const styles = timezoneStyles();

  return (
    <span {...withNoTranslate()} css={[styles.root, customStyle]}>
      ({timezone})
    </span>
  );
};

const timezoneStyles = () => {
  return {
    root: css`
      font-size: 0.55em;
      color: #666;
      margin-left: 0.25em;
    `,
  };
};
